import React from 'react'
import { BillingSettingsPageView } from './view'
import { BillingSettingsPageLogic } from './logic'

export const BillingSettingsPage: React.FC = () => {
    return (
        <BillingSettingsPageLogic>
            <BillingSettingsPageView />
        </BillingSettingsPageLogic>
    )
}

